import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postTravelThreeSlice = createSlice({
  name: "postTravelThree",
  initialState,
  reducers: {
    postTravelThreeStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postTravelThreeSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.postMessage = action.payload.postMessage;
    },
    postTravelThreeFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postTravelThreeStart,
  postTravelThreeSuccess,
  postTravelThreeFailure,
  clearError,
  clearMessage,
} = postTravelThreeSlice.actions;

export default postTravelThreeSlice.reducer;
